module.exports = __webpack_public_path__ + "8d5a55c032f4d2829b99412b0f84e163.svg";